import React, { useState } from 'react'

import cardSVG from './moc-card.svg'
import { CardBack, CardBackContainer, CardOverlayContainer, Signature } from './styled-components'

type CardBackRotateProps = {
  autoRotate: boolean
  svgFile: string
}

const SVG = ({ svg }: { svg: string }) => <Signature dangerouslySetInnerHTML={{ __html: svg }} />

export const CardBackRotate: React.FC<CardBackRotateProps> = ({ autoRotate, svgFile }) => {
  const [rotateNum, setRotateNum] = useState(0)

  const handleClick = () => {
    setRotateNum(prev => prev + 1)
  }

  return (
    <CardBackContainer key={`rotateNum${rotateNum}`} rotated={autoRotate} onClick={handleClick}>
      <CardBack alt="Acorns Debit Card - Back" src={cardSVG} />
      <CardOverlayContainer>{svgFile && <SVG svg={svgFile} />}</CardOverlayContainer>
    </CardBackContainer>
  )
}
